import AppChrome from '../../components/AppChrome'
import HeroImageOnly from '../../components/heroes/HeroImageOnly'
import Container from '../../components/layout/Container'
import Stack from '../../components/layout/Stack'
import PageSegmentBackground from '../../components/pageSegments/PageSegmentBackground'
import PageSegmentHeading from '../../components/pageSegments/PageSegmentHeading'
import People from '../../components/people/People'

export { getServerSideProps } from '../../graphql/teamPage'

function BrixelTeamPage( { entry: teamPage } ) {
  return (
    <div>
      <AppChrome>
        <HeroImageOnly
          image={ teamPage.mainImage[ 0 ] }
        />
        <PageSegmentBackground 
          color="grey100"
          segmentType="custom"
          hasSectionTitle
          anchorId="page-title"
        >
          <Container>
            <Stack
              $top={ 12 }
              $bottom={ 12 }
              $between={ 10 }
            >

              <PageSegmentHeading
                title={ teamPage.title }
              />
              <People people={ teamPage.people } />
            </Stack>
          </Container>
        </PageSegmentBackground>
      </AppChrome>
    </div>
  )
}

export default BrixelTeamPage
